import axios from "axios";
import { API_URL } from "@/config";

const http = axios.create({ baseURL: API_URL, withCredentials: true });

export interface DealMathInputs {
    vehiclePrice: number;
    taxableRebate?: number;
    nonTaxableRebate?: number;
    tradeAllowance?: number;
    tradePayoff?: number;
    warranty?: number;
    gap?: number;
    accessories?: number;
    downPayment?: number;
    salesTaxRate?: number;
    titleLicenseFee?: number;
    docFee?: number;
    deliveryFee?: number;
    apr?: number;
    termMonths?: number;
    dealType?: "FINANCE" | "CASH";
}

export interface DealMathResult {
    taxablePrice: number;
    salesTax: number;
    totalFees: number;
    totalAddOns: number;
    netTrade: number;
    cashPrice: number;
    amountFinanced: number;
    monthlyPayment: number;
    totalOfPayments: number;
    totalFinanceCharge: number;
    dealType: "FINANCE" | "CASH";
}

export interface DealRecord {
    deal_id: number;
    deal_token: string;
    deal_number: number;
    deal_dealerID: number;
    deal_status: string | null;
    deal_type: string | null;
    vehicle_id: number | null;
    customer_id: number | null;
    vYear: number | null;
    vMake: string | null;
    vModel: string | null;
    vTrim: string | null;
    vColor: string | null;
    vVin: string | null;
    vMileage: string | null;
    priceVehicle: string;
    downPayment: string | null;
    tradeAllowance: string | null;
    tradePayoff: string | null;
    apr: string | null;
    term: string | null;
    amountDDue: string | null;
    monthlypymts: string | null;
    totalPayments: string | null;
    totalFinanceCharges: string | null;
    deal_created_at: string;
}

export async function calculateDeal(inputs: DealMathInputs): Promise<DealMathResult> {
    const res = await http.post<{ ok: boolean; result: DealMathResult }>("/deals/calculate", inputs);
    return res.data.result;
}

export async function submitCustomerDeal(payload: Record<string, unknown>): Promise<{ deal: DealRecord; math: DealMathResult }> {
    const res = await http.post<{ ok: boolean; deal: DealRecord; math: DealMathResult }>("/deals/customer/submit", payload);
    return res.data;
}

export async function getDealsByDealer(dealerId: number, status?: string): Promise<DealRecord[]> {
    const params = new URLSearchParams({ dealerId: String(dealerId) });
    if (status) params.set("status", status);
    const res = await http.get<DealRecord[]>(`/deals?${params}`);
    return res.data;
}

export async function getMyDeals(): Promise<DealRecord[]> {
    const res = await http.get<DealRecord[]>("/deals/customer/mine");
    return res.data;
}

export async function getDeal(dealId: number): Promise<DealRecord> {
    const res = await http.get<DealRecord>(`/deals/${dealId}`);
    return res.data;
}

export async function updateDealStatus(dealId: number, status: string, dealerRoom: string, counterOffer?: Partial<DealMathInputs>): Promise<DealRecord> {
    const res = await http.patch<{ ok: boolean; deal: DealRecord }>(`/deals/${dealId}/status`, {
        status,
        dealerRoom,
        counterOffer,
    });
    return res.data.deal;
}
